import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=1efd1166&"
import script from "./DataTable.vue?vue&type=script&lang=js&"
export * from "./DataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1efd1166')) {
      api.createRecord('1efd1166', component.options)
    } else {
      api.reload('1efd1166', component.options)
    }
    module.hot.accept("./DataTable.vue?vue&type=template&id=1efd1166&", function () {
      api.rerender('1efd1166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utils/DataTable.vue"
export default component.exports